import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_CLIENT_SITE_ESTIMATION } from "../../constant/Apipath";
// import { FETCH_CLIENT_SITE_ESTIMATION2 } from "../../constant/Apipath";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  Card,
  Fab,
  Grid,
  IconButton,
  Modal,
  Stack,
  Typography,
  Alert,
  Button
} from "@mui/material";
import dayjs from "dayjs";
import InfiniteScroll from "react-infinite-scroll-component";
import { BIGrey, BILightGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import ClientEstimateAddModal from "./ClientEstimateAddModal";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { useLocation } from "react-router-dom";

export default function ClientSiteEstimates() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;

  const [onClickSelectData, setOnClickSelectData] = useState({});
  const [siteEstimateViewModal, setSiteEstimateViewModal] = useState(false);
  const [estimateData, setEstimateData] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [loader, setLoader] = useState(false); // For initial fetch
  const [isFetchingMore, setIsFetchingMore] = useState(false); // For infinite scroll fetches
  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  const LANGUAGE = ClientEnglishFallback.ClientSiteEstimates(
    multiLanguageData?.ClientSiteEstimates || {}
  );

  useEffect(() => {
    setEstimateData([]);
    setPageNo(1);
    setHasMore(true);
    setError(null);
    setLoader(true);
    getSiteEstimates(1);
  }, [location?.state?.searchText]);

  const getSiteEstimates = async (pgNo) => {
    const isInitialFetch = pgNo === 1;
    if (!isInitialFetch) {
      setIsFetchingMore(true);
    } else {
      setLoader(true);
    }
    setError(null);
    try {
      const obj = {
        PageNr: pgNo,
        NrOfRecPerPage: 20,
        FullSearch: location?.state?.searchText || "",
        UserId: userId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientEmployeeId: Number(selectedClientData?.ClientEmployeeId)
          }
        ],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };

      const res = await Postrequestcall(FETCH_CLIENT_SITE_ESTIMATION, obj, TOKEN);
      // const res = await Postrequestcall(FETCH_CLIENT_SITE_ESTIMATION2, obj, TOKEN);
      if (res.status === 200) {
        const data = res?.data?.data || [];
        if (pgNo === 1) {
          setEstimateData(data);
        } else {
          setEstimateData((prev) => [...prev, ...data]);
        }
        setHasMore(data?.length === 20);
        setPageNo((prev) => prev + 1);
      } else {
        throw new Error(`API error: ${res.status}`);
      }
    } catch (e) {
      console.error("getSiteEstimates-> Error fetching site estimates: ", e);
      setError("Failed to load estimates. Please try again.");
      setHasMore(false);
    } finally {
      if (isInitialFetch) {
        setLoader(false);
      } else {
        setIsFetchingMore(false);
      }
    }
  };

  const retryFetch = () => {
    setPageNo(1);
    setEstimateData([]);
    setHasMore(true);
    setLoader(true);
    getSiteEstimates(1);
  };

  const ListComponent = ({ data, index }) => {
    return (
      <Grid key={index} size={12} sx={{ mb: 1 }}>
        <Card
          onClick={() => {
            setOnClickSelectData(data);
            setSiteEstimateViewModal(true);
          }}
          sx={{
            borderRadius: "10px",
            padding: 2,
            boxShadow: "none",
            cursor: "pointer"
          }}>
          <Stack sx={{ mb: 1 }} spacing={1} direction={"row"}>
            <LocationOnIcon sx={{ color: CLIENT_ACCENT_COLOR }} />
            <Typography>{`${data?.clientJobCode} - ${data?.clientJobName}`}</Typography>
          </Stack>
          <Stack spacing={1} direction={"row"}>
            <Typography sx={{ color: "grey" }}>
              {`${dayjs(data?.dateCreated).format("MMMM DD, YYYY")}`}
            </Typography>
          </Stack>
        </Card>
      </Grid>
    );
  };

  const SiteEstimateViewModal = ({ isOpen, onClose, data, multiLanguageData }) => {
    const tableStyle = {
      width: "100%",
      borderCollapse: "collapse"
    };

    const headerCellStyle = {
      borderBottom: "1px solid #ccc",
      padding: "8px",
      textAlign: "left",
      fontWeight: "normal",
      color: BIGrey
    };

    const cellStyle = {
      borderBottom: "1px solid #ccc",
      padding: "8px",
      textAlign: "left"
    };

    const subtotalStyle = {
      borderBottom: "1px solid #ccc",
      padding: "8px",
      textAlign: "left",
      fontWeight: "bold",
      color: CLIENT_ACCENT_COLOR
    };

    const {
      TEXT_JOB,
      TEXT_AREA_ITEM,
      TEXT_DESCRIPTION,
      TEXT_DAYS,
      TEXT_EMPLOYEES,
      TEXT_SUB_TOTAL
    } = multiLanguageData;

    return (
      <Modal open={isOpen} onClose={onClose}>
        <div className="client-modal-responsive" style={{ padding: "0px 10px 10px 10px" }}>
          <div className="action-button-container" style={{ justifyContent: "flex-end" }}>
            <IconButton onClick={onClose} sx={{ color: CLIENT_ACCENT_COLOR || BILightGrey }}>
              <CloseIcon />
            </IconButton>
          </div>
          <Grid>
            <Grid>
              <Typography sx={{ color: BIGrey }}>{TEXT_JOB}</Typography>
              <Typography>{`${data?.clientJobCode} ${data?.clientJobName}`}</Typography>
              <Typography gutterBottom sx={{ fontWeight: "bold" }}>
                {TEXT_AREA_ITEM}
              </Typography>
            </Grid>
            <Grid>
              <div style={{ maxHeight: "300px", overflowY: "auto", scrollbarWidth: "none" }}>
                <table style={tableStyle}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          ...headerCellStyle,
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 1
                        }}>
                        {TEXT_DESCRIPTION}
                      </th>
                      <th
                        style={{
                          ...headerCellStyle,
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 1
                        }}>
                        {TEXT_DAYS}
                      </th>
                      <th
                        style={{
                          ...headerCellStyle,
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 1
                        }}>
                        {TEXT_EMPLOYEES}
                      </th>
                      <th
                        style={{
                          ...headerCellStyle,
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 1
                        }}>
                        {TEXT_SUB_TOTAL}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.siteEstimationList?.map((item, index) => (
                      <tr key={index}>
                        <td style={cellStyle}>{item?.description}</td>
                        <td style={cellStyle}>{item?.days?.toFixed(2)}</td>
                        <td style={cellStyle}>{item?.employees}</td>
                        <td style={subtotalStyle}>{parseInt(item?.subTotal || 0).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Grid>
          </Grid>
        </div>
      </Modal>
    );
  };

  return (
    <div id="scrollableDiv" style={{ height: "95vh", overflow: "auto" }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
          <Button onClick={retryFetch} sx={{ ml: 2 }} variant="outlined" size="small">
            {LANGUAGE.BUTTON_RETRY}
            Retry
          </Button>
        </Alert>
      )}
      {loader && (estimateData?.length === 0) && <Loader fullScreen />}
      <InfiniteScroll
        dataLength={estimateData?.length || 0}
        next={() => getSiteEstimates(pageNo)}
        hasMore={hasMore}
        loader={
          isFetchingMore && (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Loader />
            </div>
          )
        }
        scrollThreshold={0.7}
        scrollableTarget="scrollableDiv"
        endMessage={
          estimateData.length > 0 && !hasMore ? (
            <Typography sx={{ textAlign: "center", mt: 2, color: BIGrey }}>
              {LANGUAGE.TEXT_END_MESSAGE}
            </Typography>
          ) : null
        }>
        {estimateData?.length === 0 && !loader && !error ? (
          <Stack sx={{ width: "100%", justifyContent: "center", alignItems: "center" }} height="85vh">
            <Typography sx={{ textAlign: "center", mt: 2, color: BIGrey }}>
              {LANGUAGE.TEXT_NO_ESTIMATE}
            </Typography>
          </Stack>
        ) : (
          estimateData?.map((item, index) => <ListComponent data={item} key={index} index={index} />)
        )}
      </InfiniteScroll>
      <SiteEstimateViewModal
        data={onClickSelectData}
        isOpen={siteEstimateViewModal}
        onClose={() => setSiteEstimateViewModal(false)}
        multiLanguageData={LANGUAGE}
      />
      <Fab
        onClick={() => setAddModal(true)}
        style={{ position: "fixed", bottom: "20px", right: "20px" }}
        sx={{
          bgcolor: CLIENT_ACCENT_COLOR,
          "&:hover": { bgcolor: CLIENT_ACCENT_COLOR }
        }}
        aria-label="add">
        <AddIcon style={{ color: "white" }} />
      </Fab>
      {addModal && (
        <ClientEstimateAddModal
          isOpen={addModal}
          onClose={() => setAddModal(false)}
          reLoadData={() => getSiteEstimates(1)}
        />
      )}
    </div>
  );
}
